<template>
    <footer class=" text-center py-4">
        <div class="container">
            <!-- <p> -->
            <div class="footImg">

            </div>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="text-muted">
                <span>Copyright© 2024，AKF COSMETIC CO.,LTD. </span><br>
                <img src="../assets/images/guohui.png" alt="国徽"
                    style="width:20px; height:auto; vertical-align:middle; margin: 0 5px;">
                <span>粤ICP备2024245456号-3</span>
            </a>
            <!-- </p> -->
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style scoped>
/* 样式 */
@media only screen and (max-width: 996px) {

    .text-muted {
        text-decoration: none;
        /* 移除下划线 */
        color: black;
        /* 设置你想要的链接颜色 */
        font-size: 0.8rem;
    }

    /* 移动端 */
    .footImg {
        height: 6rem;
        background-image: url("../assets/images/mobile/footer.jpg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .container {
        padding: 0;
    }
}

/* 桌面端 */
@media only screen and (min-width: 996px) {

    .text-muted {
        text-decoration: none;
        /* 移除下划线 */
        color: black;
        /* 设置你想要的链接颜色 */
    }

    .footImg {
        display: none;
    }
}</style>